/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmStreamChunkMessage } from '../../models/llm-stream-chunk-message';

export interface GetnotificationsLlmStreamChunkSchema$Params {
}

export function getnotificationsLlmStreamChunkSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsLlmStreamChunkSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamChunkMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsLlmStreamChunkSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LlmStreamChunkMessage>;
    })
  );
}

getnotificationsLlmStreamChunkSchema.PATH = '/api/hubs/notifications/LlmStreamChunk';
